import { colors, fonts } from 'src/constants/theme';
import { isWeb } from 'src/utils';
import { responsiveWidth } from 'src/utils/responsive';

export const headerStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  participantsList: {
    width: 50,
  },
  participant: {
    position: 'absolute',
    borderRadius: '50%',
    border: '1px solid #fff',
  },
  details: {
    maxWidth: '95%',
  },
  summary: {
    fontFamily: fonts.bold,
    marginBottom: 3,
  },
};

export const getParticipantListStyles = ({ participantsCount }) => {
  let width = 50;
  if (participantsCount > 1) width = 55;
  if (participantsCount > 2) width = 65;

  return { ...headerStyles.participantsList, width };
};

export const getParticipantStyles = ({ offset, zIndex }) => {
  return { ...headerStyles.participant, left: offset * 8, zIndex };
};

const styles = {
  // old version of styles
  info: {
    paddingLeft: 10,
    backgroundColor: 'transparent',

    maxWidth: isWeb() ? '100%' : responsiveWidth(100),
  },
  avatar: {
    height: 37,
    width: 37,
    backgroundColor: colors.darkblue2,
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default styles;
